import { AuthenticationMethod } from "../api";

export enum CredentialKey {
    username = "username",
    password = "password",
    email = "email",
    apiKey = "api-key",
    apiToken = "api-token",
    tenantId = "tenant-id",
    clientId = "client-id",
    authCode = "auth-code",
    oktaAppEmbeddedUrl = "okta-app-embedded-url",
    oktaUsername = "okta-username",
    oktaPassword = "okta-password",
    servicePrincipalSecret = "service-principal-secret",
    refresh_token = "refresh_token",
    certificateThumbprint = "certificate-thumbprint",
    certificatePrivateKey = "certificate-private-key",
    salesforceInstanceUrl = "salesforce-instance-url",
    serviceNowInstanceUrl = "service-now-instance-url",
    clientSecret = "client-secret",
    servicePrincipalObjectId = "service-principal-object-id",
    workspaceId = "workspace-id",
}

export const SecretCredentialsKeys = [
    CredentialKey.password,
    CredentialKey.apiKey,
    CredentialKey.apiToken,
    CredentialKey.authCode,
    CredentialKey.refresh_token,
    CredentialKey.oktaPassword,
    CredentialKey.servicePrincipalSecret,
    CredentialKey.certificatePrivateKey,
    CredentialKey.clientSecret,
];
export const MultilineCredentialsKeys = [CredentialKey.certificatePrivateKey];

export const CredentialFields: { [key: string]: string } = {
    [CredentialKey.username]: "integrationPage.authDetails.usernameFieldKey",
    [CredentialKey.password]: "integrationPage.authDetails.passwordFieldKey",
    [CredentialKey.email]: "integrationPage.authDetails.emailFieldKey",
    [CredentialKey.apiKey]: "integrationPage.authDetails.apiKeyFieldKey",
    [CredentialKey.tenantId]: "integrationPage.authDetails.tenantIdFieldKey",
    [CredentialKey.clientId]: "integrationPage.authDetails.clientIdFieldKey",
    [CredentialKey.oktaAppEmbeddedUrl]: "integrationPage.authDetails.oktaAppEmbeddedUrlFieldKey",
    [CredentialKey.oktaUsername]: "integrationPage.authDetails.oktaUsernameFieldKey",
    [CredentialKey.oktaPassword]: "integrationPage.authDetails.oktaPasswordFieldKey",
    [CredentialKey.servicePrincipalSecret]: "integrationPage.authDetails.servicePrincipalSecretFieldKey",
    [CredentialKey.certificateThumbprint]: "integrationPage.authDetails.clientCertificateThumbprintFieldKey",
    [CredentialKey.certificatePrivateKey]: "integrationPage.authDetails.clientCertificatePrivateKeyFieldKey",
    [CredentialKey.salesforceInstanceUrl]: "integrationPage.authDetails.salesforceInstanceUrlFieldKey",
    [CredentialKey.apiToken]: "integrationPage.authDetails.apiTokenFieldKey",
    [CredentialKey.clientSecret]: "integrationPage.authDetails.clientSecretFieldKey",
    [CredentialKey.servicePrincipalObjectId]: "integrationPage.authDetails.servicePrincipalObjectIdFieldKey",
    [CredentialKey.serviceNowInstanceUrl]: "integrationPage.authDetails.serviceNowInstanceUrlFieldKey",
    [CredentialKey.workspaceId]: "integrationPage.authDetails.workspaceIdFieldKey",
};

export const AuthenticationMethodToLabelPath: { [key: string]: string } = {
    [AuthenticationMethod.userpassword]: "integrationPage.authDetails.userPasswordMethod",
    [AuthenticationMethod.apikey]: "integrationPage.authDetails.apiKeyMethod",
    [AuthenticationMethod.oauthAuthorizationCode]: "integrationPage.authDetails.oauthMethod",
    [AuthenticationMethod.oktasso]: "integrationPage.authDetails.oktaSsoMethod",
    [AuthenticationMethod.serviceprincipal]: "integrationPage.authDetails.servicePrincipalMethod",
    [AuthenticationMethod.certwithuserpassword]: "integrationPage.authDetails.certWithUserPasswordMethod",
    [AuthenticationMethod.apitoken]: "integrationPage.authDetails.apiTokenMethod",
    [AuthenticationMethod.oauthClientCredentialsFlow]: "integrationPage.authDetails.oauthClientCredentialsFlowMethod",
    [AuthenticationMethod.ppZenityMultiTenantAppServicePrincipal]: "integrationPage.authDetails.ppZenityMultiTenantAppServicePrincipalMethod",
};
